import _               from 'lodash'
import React           from 'react'
import Immutable       from 'immutable'
import { FormControl } from 'react-bootstrap'

export default class Select extends React.Component
  render: ->
    handler = (e) => @props.onChange(@fromOptionValue(e.target.value))

    <FormControl componentClass="select" value={@toOptionValue(@props.value)} onChange={handler}>
      {@options()}
    </FormControl>

  options: ->
    options = @coerceOptions(@props.options)

    if @props.allowBlank
      options = _.concat([['--', null]], options)

    options.map ([text, value]) =>
      <option key={@toOptionValue(value)} value={@toOptionValue(value)}>{text}</option>

  fromOptionValue: (value) ->
    if value == "null"
      null
    else if value == "true"
      true
    else if value == "false"
      false
    else
      value

  toOptionValue: (value) ->
    if value == null then "null" else value

  # TODO: validate options format
  coerceOptions: (options) ->
    if _.isArray(options)
      options
    else if _.isPlainObject(options)
      _.toPairs(options)
    else if Immutable.List.isList(options)
      options.toArray()
    else
      throw new Error('unknown select options format:', options)
